const es = {
  // Navbar
  "navbar.por_que_ia": "Por qué IA",
  "navbar.servicios_agentes": "Servicios & agentes",
  "navbar.impacto_roi": "Impacto ROI",
  "navbar.como_trabajamos": "Cómo trabajamos",
  "navbar.diagnostico_roi": "Diagnóstico ROI",
  "navbar.reservar_consulta": "Solicitar Diagnóstico ROI",

  // Hero
  "hero.badge": "Agencia de automatización con IA · Impact-First",
  "hero.h1_part1": "Convierte la IA en ",
  "hero.h1_gradient": "negocio real",
  "hero.h1_part3": " para tu empresa",
  "hero.subtext": "En AIdeal Media diseñamos, entrenamos y desplegamos agentes de IA y automatizaciones a medida que reducen costes operativos y multiplican tu facturación. Con métricas transparentes.",
  "hero.cta": "Solicitar Diagnóstico ROI",

  // WhyAI
  "why.badge": "Por qué IA · Por qué ahora",
  "why.h2_part1": "La ventaja no es tener IA. Es ",
  "why.h2_gradient": "saber convertirla en negocio",
  "why.stats_part1": "El ",
  "why.stats_78": "78%",
  "why.stats_part2": " de las empresas ya prueban IA. Solo el ",
  "why.stats_12": "12%",
  "why.stats_part3": " obtiene retorno. La diferencia: estrategia, integración con tus procesos y agentes entrenados con tu propia data.",
  "why.reason0_title": "Escala sin contratar más equipo",
  "why.reason0_desc": "Agentes IA que operan 24/7 en ventas, soporte y marketing. Tu equipo humano se enfoca en decisiones, no en tareas repetitivas.",
  "why.reason1_title": "Decisiones basadas en datos",
  "why.reason1_desc": "Dashboards inteligentes y predicciones accionables. Sabes exactamente qué canal, campaña y agente está generando ingresos.",
  "why.reason2_title": "Implementación segura y auditada",
  "why.reason2_desc": "Integraciones nativas con tu software (HubSpot, Shopify, Notion, Slack) con logs, control de accesos y cumplimiento de privacidad y protección de datos (GDPR / SOC2).",
  "why.reason3_title": "ROI garantizado en 90 días",
  "why.reason3_desc": "En los primeros 90 días acordamos objetivos medibles y te mostramos, con total transparencia, los resultados obtenidos y el impacto real en tu empresa.",

  // Services
  "services.badge": "Servicios & agentes",
  "services.h2_part1": "Un equipo de IA para impulsar ",
  "services.h2_gradient": "tu empresa",
  "services.description": "Cada solución se despliega en 4–8 semanas y se integra con tus herramientas actuales. Con métricas transparentes y un contrato de resultados.",
  "services.item0_title": "Agente de ventas IA",
  "services.item0_desc": "Cualifica leads, agenda reuniones y responde objeciones en WhatsApp, web y email. Se integra con tu CRM.",
  "services.item0_feature0": "Multicanal 24/7",
  "services.item0_feature1": "CRM & HubSpot sync",
  "services.item0_feature2": "Voice + Text",
  "services.item0_metric": "+37% conversión",
  "services.item1_title": "Agente de soporte nivel 1",
  "services.item1_desc": "Resuelve el 68% de tickets sin intervención humana. Escala inteligente a agentes reales cuando toca.",
  "services.item1_feature0": "Knowledge Base RAG",
  "services.item1_feature1": "Zendesk / Intercom",
  "services.item1_feature2": "Multi-idioma",
  "services.item1_metric": "-52% tiempo de respuesta",
  "services.item2_title": "Automatización de marketing",
  "services.item2_desc": "Contenido, emails, ads y segmentación autogenerada según tu target. Optimización continua con IA.",
  "services.item2_feature0": "Copy generativo",
  "services.item2_feature1": "A/B testing IA",
  "services.item2_feature2": "Meta + Google Ads",
  "services.item2_metric": "3.1x ROAS",
  "services.item3_title": "Data & Business Intelligence",
  "services.item3_desc": "Unificamos tus datos en un servidor y creamos dashboards predictivos con alertas accionables.",
  "services.item3_feature0": "Supabase / BigQuery",
  "services.item3_feature1": "Forecasting IA",
  "services.item3_feature2": "Slack alerts",
  "services.item3_metric": "100% visibilidad",
  "services.item4_title": "Custom AI Apps",
  "services.item4_desc": "Desarrollamos productos internos con IA a medida: buscadores semánticos, copilots, workflows.",
  "services.item4_feature0": "RAG + Vector DB",
  "services.item4_feature1": "OpenAI / Anthropic",
  "services.item4_feature2": "Full ownership",
  "services.item4_metric": "6-8 sem. delivery",
  "services.item5_title": "Consultoría & Roadmap IA",
  "services.item5_desc": "Auditamos tus procesos, priorizamos casos de uso y diseñamos un roadmap de IA con ROI.",
  "services.item5_feature0": "ROI framework",
  "services.item5_feature1": "Change mgmt",
  "services.item5_feature2": "KPIs claros",
  "services.item5_metric": "Roadmap 4 sem.",

  // RoiImpact
  "roi.badge": "Impacto ROI",
  "roi.h2_part1": "Números reales",
  "roi.h2_gradient": "de clientes reales",
  "roi.description": "Resultados verificables. Medición continua en dashboards compartidos con métricas consolidadas de los últimos 12 meses.",
  "roi.kpi0_label": "ROI promedio a 90 días",
  "roi.kpi0_delta": "+220%",
  "roi.kpi1_label": "Reducción coste operativo",
  "roi.kpi1_delta": "vs baseline",
  "roi.kpi2_label": "Leads cualificados / mes",
  "roi.kpi2_delta": "+37% vs Q1",
  "roi.kpi3_label": "Tiempo de respuesta soporte",
  "roi.kpi3_delta": "-52%",
  "roi.case0_industry": "eCommerce · Retail",
  "roi.case0_quote": "En 11 semanas su agente de ventas nos generó 340 demos cualificadas. Nuestro CAC bajó un 34% y el equipo comercial escaló sin contratar.",
  "roi.case0_author": "Marta Iglesias",
  "roi.case0_role": "Head of Growth, Vento Retail",
  "roi.case0_metric0_k": "+37%",
  "roi.case0_metric0_v": "Conversión",
  "roi.case0_metric1_k": "-34%",
  "roi.case0_metric1_v": "CAC",
  "roi.case0_metric2_k": "3.9x",
  "roi.case0_metric2_v": "ROI",
  "roi.case1_industry": "SaaS · B2B",
  "roi.case1_quote": "Automatizamos el 68% de nuestros tickets con su agente RAG. El equipo de soporte pasó de apagar fuegos a liderar proyectos estratégicos.",
  "roi.case1_author": "David Ruiz",
  "roi.case1_role": "COO, Metrikai",
  "roi.case1_metric0_k": "-52%",
  "roi.case1_metric0_v": "Tiempo resp.",
  "roi.case1_metric1_k": "68%",
  "roi.case1_metric1_v": "Tickets auto",
  "roi.case1_metric2_k": "4.1x",
  "roi.case1_metric2_v": "ROI",
  "roi.case2_industry": "Real Estate · PropTech",
  "roi.case2_quote": "Reemplazamos 3 herramientas por un único copilot de IA para reservas. Ingresos directos +28% en nuestro primer trimestre de uso.",
  "roi.case2_author": "Marcus Vance",
  "roi.case2_role": "Head of Operations, PropTech Group",
  "roi.case2_metric0_k": "+28%",
  "roi.case2_metric0_v": "Ingreso directo",
  "roi.case2_metric1_k": "-3",
  "roi.case2_metric1_v": "Herramientas",
  "roi.case2_metric2_k": "3.4x",
  "roi.case2_metric2_v": "ROI",

  // Process
  "process.badge": "Cómo trabajamos",
  "process.h2_part1": "Un proceso de",
  "process.h2_gradient": "4 pasos",
  "process.h2_part3": ", simple y efectivo",
  "process.description": "Del diagnóstico a agentes en producción en menos de 8 semanas. Un proceso claro, con objetivos medibles y contrato de resultados.",
  "process.step0_title": "Diagnóstico ROI",
  "process.step0_desc": "Auditamos tus procesos, datos y software. Detectamos los 3 casos de uso IA con mayor retorno.",
  "process.step0_duration": "1 semana",
  "process.step1_title": "Diseño & Roadmap",
  "process.step1_desc": "Definimos arquitectura, KPIs y sprints. Firmamos un contrato con objetivos medibles.",
  "process.step1_duration": "2 semanas",
  "process.step2_title": "Build & Entrenamiento",
  "process.step2_desc": "Desplegamos los agentes de IA, integramos con tu software y los entrenamos con tus propios datos.",
  "process.step2_duration": "4–6 semanas",
  "process.step3_title": "Optimización continua",
  "process.step3_desc": "Iteramos, medimos y escalamos. Reportes mensuales con impacto real en tu facturación.",
  "process.step3_duration": "Ongoing",

  // LeadForm
  "form.badge": "Diagnóstico ROI personalizado",
  "form.h2_part1": "Descubre en 24 horas dónde la IA ",
  "form.h2_gradient": "multiplica tu ROI",
  "form.h2_part3": "",
  "form.description": "Cuéntanos sobre tu empresa y te enviamos un diagnóstico personalizado con los 3 casos de uso de IA con mayor potencial de retorno, listo para evaluar con tu equipo.",
  "form.benefit0": "Reporte con casos de uso priorizados",
  "form.benefit1": "Estimación de ROI y coste por caso",
  "form.benefit2": "Roadmap sugerido a 90 días",
  "form.benefit3": "Sesión de 30 min con un estratega IA",
  "form.talk_first": "¿Prefieres hablar antes?",
  "form.talk_cta": "Habla con un Experto en IA",
  "form.label_name": "Nombre completo *",
  "form.placeholder_name": "Ana Pérez",
  "form.label_email": "Email de trabajo *",
  "form.placeholder_email": "anaperez@empresa.com",
  "form.label_company": "Empresa *",
  "form.placeholder_company": "Nombre de tu empresa",
  "form.label_website": "Website",
  "form.placeholder_website": "empresa.com",
  "form.label_industry": "Sector *",
  "form.placeholder_industry": "Selecciona un sector",
  "form.label_budget": "Presupuesto mensual estimado *",
  "form.placeholder_budget": "Selecciona rango",
  "form.label_goals": "Objetivos principales (elige uno o varios)",
  "form.label_message": "Cuéntanos brevemente tu reto (opcional)",
  "form.placeholder_message": "Ej. Queremos automatizar la cualificación de leads en WhatsApp...",
  "form.max_chars": "Máx. 500 caracteres",
  "form.privacy_text": "Al enviar aceptas nuestra política de privacidad. No hacemos spam. Respuesta en menos de 24h laborables.",
  "form.submit_label": "Solicitar Diagnóstico",
  "form.submitting": "Enviando...",
  "form.success_title": "¡Solicitud recibida!",
  "form.success_desc": "En menos de 24h te enviaremos tu diagnóstico ROI personalizado. Mientras tanto, ¿quieres reservar tu sesión con un estratega?",
  "form.success_cta": "Agendar sesión ahora",
  "form.error_char_limit": "El mensaje no puede superar los 500 caracteres.",
  "form.error_send": "No pudimos enviar tu solicitud. Inténtalo de nuevo en unos minutos.",
  "form.error_network": "Ha ocurrido un error de red. Comprueba tu conexión e inténtalo de nuevo.",
  "form.industry_0": "eCommerce / Retail",
  "form.industry_1": "SaaS / B2B",
  "form.industry_2": "Servicios profesionales",
  "form.industry_3": "Hospitality / Turismo",
  "form.industry_4": "Salud / Wellness",
  "form.industry_5": "Educación",
  "form.industry_6": "Otro",
  "form.budget_0": "Menos de 3.000 €",
  "form.budget_1": "3.000 € – 8.000 €",
  "form.budget_2": "8.000 € – 20.000 €",
  "form.budget_3": "Más de 20.000 €",
  "form.goal_0": "Automatizar ventas",
  "form.goal_1": "Automatizar soporte",
  "form.goal_2": "Marketing con IA",
  "form.goal_3": "Data & BI",
  "form.goal_4": "Custom AI app",

  // FAQ
  "faq.badge": "FAQ",
  "faq.h2_part1": "Preguntas",
  "faq.h2_gradient": "frecuentes",
  "faq.q0": "¿Cuánto tiempo toma la implementación completa?",
  "faq.a0": "Nuestros despliegues toman entre 4 y 8 semanas, dependiendo de la complejidad. Recibirás un roadmap claro desde el primer día.",
  "faq.q1": "¿Trabajan con empresas pequeñas o solo con grandes compañías?",
  "faq.a1": "Trabajamos con empresas en crecimiento y grandes marcas que busquen automatizar procesos reales para escalar sin aumentar sus costes fijos.",
  "faq.q2": "¿Qué pasa con nuestra información? ¿Es segura y privada?",
  "faq.a2": "Su información está 100% protegida. No usamos sus datos para entrenar modelos públicos y cumplimos con estrictos estándares de privacidad y encriptación.",
  "faq.q3": "¿Ofrecen alguna garantía sobre los resultados o el ROI?",
  "faq.a3": "Cuando firmamos el contrato, definimos objetivos claros y medibles que nuestro despliegue debe alcanzar durante los primeros 90 días.",
  "faq.q4": "¿Qué tecnología utilizan para los agentes de IA?",
  "faq.a4": "Utilizamos los modelos más avanzados del mercado integrados directamente con la base de conocimientos y sistemas propios de tu empresa.",
  "faq.q5": "¿Necesitamos tener toda nuestra información ordenada antes de empezar?",
  "faq.a5": "No es necesario. Como parte de nuestro diagnóstico inicial, te ayudamos a estructurar y conectar tus datos para que los agentes funcionen perfectamente.",

  // CTA
  "cta.badge": "¿Listo para escalar?",
  "cta.h2_part1": "Empieza a operar con IA ",
  "cta.h2_gradient": "esta semana",
  "cta.h2_part3": "",
  "cta.description": "30 minutos con un estratega para definir un plan de acción y una estimación del ROI a 90 días.",
  "cta.button": "Solicitar mi Diagnóstico ROI",

  // Footer
  "footer.tagline": "AI Tools for Digital Business",
  "footer.description_line1": "Diseñamos agentes IA y automatización",
  "footer.description_line2": "con contrato de resultados",
  "footer.locations": "Operaciones: USA • Unión Europea • LATAM",
  "footer.col_services": "SERVICIOS",
  "footer.col_navigation": "NAVEGACIÓN",
  "footer.service_0": "Agente de ventas IA",
  "footer.service_1": "Agente de soporte nivel 1",
  "footer.service_2": "Automatización de marketing",
  "footer.service_3": "Data & Business Intelligence",
  "footer.service_4": "Custom AI Apps",
  "footer.service_5": "Consultoría & Roadmap IA",
  "footer.nav_why_ai": "Por qué IA",
  "footer.nav_roi_impact": "Impacto ROI",
  "footer.nav_how_we_work": "Cómo trabajamos",
  "footer.nav_faq": "Preguntas frecuentes",
  "footer.nav_roi_roadmap": "Solicitar diagnóstico ROI",
  "footer.copyright": "© 2026 AIdeal Media. Todos los derechos reservados",
  "footer.privacy": "Privacidad",
  "footer.terms": "Términos",
  "footer.cookies": "Cookies",

  // Shared Legal
  "legal.badge": "Aviso Legal",
  "legal.back_to_home": "Volver al inicio",
  "legal.subtitle_privacy": "Fecha de entrada en vigor: 7 de agosto de 2026 | Entidad: AIDEAL LLC (Texas, EE. UU.)",
  "legal.subtitle_terms": "Fecha de entrada en vigor: 7 de agosto de 2026 | Entidad: AIDEAL LLC (Texas, EE. UU.)",
  "legal.subtitle_cookies": "Fecha de entrada en vigor: 7 de agosto de 2026 | Entidad: AIDEAL LLC (Texas, EE. UU.)",
  "legal.contact_title": "Contacto Legal:",
  "legal.contact_entity": "AIDEAL LLC — Departamento Legal",
  "legal.contact_email": "Correo electrónico: info@aidealmedia.info",
  "legal.contact_location": "Texas, Estados Unidos",

  // Privacy Policy
  "privacy.title": "Política de Privacidad",
  "privacy.s1_title": "1. Introducción",
  "privacy.s1_text": "AIDEAL LLC («nosotros», «nuestro» o «la Compañía»), bajo la marca comercial AIdeal Media, se compromete a proteger la privacidad de nuestros usuarios, clientes y visitantes («tú»). Esta política detalla cómo gestionamos los datos personales conforme a la Ley de Privacidad y Seguridad de Datos de Texas (TDPSA) y al Reglamento General de Protección de Datos (RGPD) de la Unión Europea.",
  "privacy.s2_title": "2. Base legal para el tratamiento de datos (RGPD)",
  "privacy.s2_intro": "Para los usuarios ubicados en el Espacio Económico Europeo (EEE), tratamos tus datos bajo las siguientes bases legales:",
  "privacy.s2_base0_title": "Ejecución de un contrato",
  "privacy.s2_base0_text": "Para ofrecer diagnósticos de ROI y ejecutar los servicios de implementación de IA.",
  "privacy.s2_base1_title": "Consentimiento",
  "privacy.s2_base1_text": "Para el envío de comunicaciones comerciales y el uso de cookies no esenciales.",
  "privacy.s2_base2_title": "Interés legítimo",
  "privacy.s2_base2_text": "Para garantizar la seguridad del sitio web, optimizar nuestros modelos de inteligencia artificial y realizar análisis de negocio.",
  "privacy.s2_base3_title": "Obligación legal",
  "privacy.s2_base3_text": "Para cumplir con las normativas fiscales y reglamentarias aplicables.",
  "privacy.s3_title": "3. Recopilación de datos y finalidad",
  "privacy.s3_text": "Recabamos datos identificativos (nombre, correo electrónico, teléfono), datos operativos empresariales (presupuestos, flujos de trabajo) y datos técnicos de navegación (dirección IP, cookies). Esta información se utiliza exclusivamente para elaborar hojas de ruta de IA estratégicas, gestionar contratos de prestación de servicios y asegurar la infraestructura digital.",
  "privacy.s4_title": "4. Transferencias internacionales de datos",
  "privacy.s4_text": "AIDEAL LLC tiene su sede principal en Texas, EE. UU. Al utilizar nuestros servicios, reconoces y aceptas que tus datos personales serán transferidos y tratados en Estados Unidos. Para los usuarios de la UE, garantizamos un nivel de protección adecuado mediante la aplicación de Cláusulas Contractuales Tipo (CCT) aprobadas por la Comisión Europea o acogiéndonos al Marco de Privacidad de Datos UE-EE. UU. cuando corresponda.",
  "privacy.s5_title": "5. Tus derechos (EEE y Texas)",
  "privacy.s5_intro": "Independientemente de tu lugar de residencia, te asisten los siguientes derechos sobre tus datos:",
  "privacy.s5_right0": "Derecho de acceso: Solicitar una copia de la información que conservamos sobre ti.",
  "privacy.s5_right1": "Derecho de rectificación: Corregir datos inexactos o incompletos.",
  "privacy.s5_right2": "Derecho de supresión («al olvido»): Solicitar la eliminación de tus datos cuando ya no sean necesarios.",
  "privacy.s5_right3": "Derecho a la limitación: Restringir el tratamiento de tus datos en supuestos específicos.",
  "privacy.s5_right4": "Derecho a la portabilidad: Recibir tus datos en un formato estructurado y de uso común.",
  "privacy.s5_right5": "Derecho de oposición: Oponerte al tratamiento basado en el interés legítimo o en la mercadotecnia directa.",
  "privacy.s5_right6": "Derecho de retirada del consentimiento: Revocar tu autorización comercial en cualquier momento.",
  "privacy.s5_contact": "Para ejercer estos derechos, contacta a: info@aidealmedia.info.",

  // Terms of Service
  "terms.title": "Términos de Servicio",
  "terms.s1_title": "1. Aceptación de los términos",
  "terms.s1_text": "Al acceder a este sitio web o solicitar un diagnóstico de ROI, aceptas someterte a estos Términos de Servicio y a todas las leyes aplicables del Estado de Texas y de los Estados Unidos.",
  "terms.s2_title": "2. Alcance de los servicios",
  "terms.s2_text": "AIDEAL LLC presta servicios de consultoría de IA, desarrollo de agentes y automatización. Todas las estimaciones preliminares, proyecciones de ROI y diagnósticos ofrecidos a través de la web tienen carácter meramente informativo y no constituyen una garantía vinculante de resultados hasta la firma formal de un contrato marco de prestación de servicios (Master Service Agreement o MSA).",
  "terms.s3_title": "3. Condiciones de pago",
  "terms.s3_text": "Para los clientes internacionales y de la Unión Europea, los pagos deben efectuarse en dólares estadounidenses (USD) salvo que se pacte expresamente lo contrario por escrito. En el caso de mantenimientos de IA recurrentes o agentes bajo modelo SaaS, las contraprestaciones se abonarán mediante transferencia bancaria o tarjeta de crédito en un plazo de 15 o 30 días (Net 15 o Net 30), según se especifique en la orden de trabajo correspondiente.",
  "terms.s4_title": "4. Propiedad intelectual",
  "terms.s4_text": "AIDEAL LLC se reserva la titularidad exclusiva de todas las metodologías propietarias, código fuente y arquitecturas de IA empleadas para la ejecución de los servicios. Al cliente se le otorga una licencia limitada y no exclusiva para utilizar los entregables finales exclusivamente en el marco de sus operaciones comerciales internas.",
  "terms.s5_title": "5. Limitación de responsabilidad",
  "terms.s5_text": "En la máxima medida permitida por las leyes de Texas, AIDEAL LLC no asumirá responsabilidad alguna por daños indirectos, incidentales o consecuentes (incluyendo la pérdida de beneficios) derivados del uso de nuestra web o de las estimaciones preliminares de IA. La responsabilidad total acumulada por cualquier reclamación no excederá en ningún caso el importe abonado por el cliente por el servicio específico objeto de controversia.",
  "terms.s6_title": "6. Ley aplicable y jurisdicción",
  "terms.s6_text": "Estos términos se rigen e interpretan conforme a las leyes del Estado de Texas, EE. UU. Cualquier disputa o controversia derivada de estas condiciones o de nuestros servicios se someterá exclusivamente a la jurisdicción de los tribunales estatales o federales con sede en Texas.",

  // Cookie Policy
  "cookies.title": "Política de Cookies",
  "cookies.s1_title": "1. ¿Qué son las cookies?",
  "cookies.s1_text": "Las cookies son pequeños archivos de texto que se almacenan en tu dispositivo para permitirnos reconocerte, optimizar tu experiencia de navegación y analizar el rendimiento de nuestra plataforma.",
  "cookies.s2_title": "2. Categorías de cookies que utilizamos",
  "cookies.s2_cat0_title": "Estrictamente necesarias",
  "cookies.s2_cat0_text": "Indispensables para el funcionamiento técnico y la seguridad del sitio web. No se pueden desactivar.",
  "cookies.s2_cat1_title": "De rendimiento y análisis",
  "cookies.s2_cat1_text": "Nos permiten contabilizar las visitas y fuentes de tráfico (por ejemplo, Google Analytics) para medir y mejorar el funcionamiento de la web.",
  "cookies.s2_cat2_title": "De funcionalidad",
  "cookies.s2_cat2_text": "Facilitan que el sitio ofrezca una personalización avanzada según tus interacciones previas.",
  "cookies.s2_cat3_title": "De publicidad y elaboración de perfiles",
  "cookies.s2_cat3_text": "Se emplean para crear un perfil de tus intereses y mostrarte anuncios relevantes en otros sitios web.",
  "cookies.s3_title": "3. Consentimiento y gestión",
  "cookies.s3_text": "Al acceder por primera vez desde la Unión Europea, aparecerá un banner de cookies que te permitirá «Aceptar todas», «Rechazar todas» o «Configurar» tus preferencias. También puedes administrar o bloquear las cookies directamente desde la configuración de tu navegador (Chrome, Safari, Firefox, Edge). Ten en cuenta que deshabilitar ciertas cookies podría mermar la operatividad de nuestras herramientas de diagnóstico de ROI.",

  // Cookie Consent Banner
  "cookieConsent.text": "Utilizamos cookies propias y de terceros para analizar el rendimiento del sitio y ofrecerle una experiencia personalizada. Consulta nuestra Política de Cookies.",
  "cookieConsent.acceptAll": "Aceptar todas",
  "cookieConsent.reject": "Rechazar",
  "cookieConsent.preferences": "Configurar",
  "cookieConsent.close": "Cerrar aviso de cookies",
};

export default es;